<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("inventory_in") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleInventory()">{{
            $t("back")
          }}</base-button>
          <base-button size="md" type="primary" :loading="isLoading" @click="handlInventoryIn()">{{
            $t("save")
          }}</base-button>
        </div>
      </div>
    </base-header>

    <div class="row">
      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
                  <h3 class="mb-0">{{ $t("wms.inventoryin_list") }}</h3>
                </label>
                <div class="col-md-6">
                  <base-input>
                    <el-select
                      v-model="StorageID"
                      :placeholder="$t('wms.storage')"
                    >
                      <el-option
                        v-for="option in Storage"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
            </template>
              <!-- List Of data -->
              <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.bill_number") }}
              </label>
              <div class="col-md-8">
                <base-input v-model="inOut.BillCode"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.bill_image") }}
              </label>
              <div class="col-md-8">
                <form>
                  <file-input @change="filesChange"></file-input>
                </form>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.note") }}
              </label>
              <div class="col-md-8">
                <base-input v-model="inOut.Note"></base-input>
              </div>
            </div>

              <div
                class="form-group row"
                v-for="(item,index) in ProductSelect"
                :key="item.ID"
              >
                <label class="col-md-6 pl-6 col-form-label form-control-label">
                  {{ item.Name }}
                </label>
                <div class="col-md-3">
                <base-input v-model="item.Quantity"></base-input>
              </div>
              <div class="col-md-3">
                <base-button
                  @click.native="handleDelete(index, item)"
                  class="remove btn-link"
                  type="danger"
                  size="md"
                  icon
                >
                  <i class="text-dtac-bt fa fa-trash text-white"></i>
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- Product -->
      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
                  <h3 class="mb-0">{{ $t("wms.menu.product") }}</h3>
                </label>
                <div class="col-md-6">
                  <base-input
                    v-model="SearchKeyword"
                    prepend-icon="fas fa-search"
                    :placeholder="$t('search')"
                  >
                  </base-input>
                </div>
              </div>
            </template>
            <div>
              <el-table
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-for="column in tableProduct"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>

                <el-table-column
                  min-width="200px"
                  align="right"
                  :label="$t('actions')"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <base-button
                      @click.native="handleIn($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      <i class="text-dtac-bt fa fa-edit"></i>
                      {{ $t("wms.inventory_in") }}
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
			  v-if="tableData.length != 0"
            >
              <div class="">
                <p class="card-category">
                  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                  {{ $t("of") }}
                  {{ total }}
                  <span v-if="selectedRows.length">
                    - &nbsp; &nbsp; {{ selectedRows.length }}
                    {{ $t("row_select") }}
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>
    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.ProductID" :placeholder="$t('wms.product')">
            <el-option
              v-for="option in Product"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          :label="$t('wms.storage')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.StorageID" :placeholder="$t('wms.storage')">
            <el-option
              v-for="option in Storage"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          v-model="md.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input v-model="inOut.ProductName" :label="$t('wms.product')">
        </base-input>

        <base-input v-model="inOut.Quantity" :label="$t('wms.amount')">
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateSelect()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showInOutModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import error from "./error";
import { mapGetters, mapActions } from "vuex";
import FileInput from '@/components/Inputs/FileInput'



export default {
  mixins: [clientPaginationMixin],
  components: {
      FileInput,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getData",
      Product: "WmsProduct/getData",
      Storage: "WmsStorage/getData",
    }),
    tableData: function () {
       if (this.SearchKeyword != "") {
        return this.Product.filter((d) => {
          return  d.Name.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1 
        });
		} else {
			return this.Product
		}
    },
    tableProduct: function () {
      return [
        {
          prop: "Name",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },
      ];
    },
    tableProductSelected: function () {
      return [
        {
          prop: "ProductName",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
	  isLoading: false,
      StorageID: 0,
      propsToSearch: ["Number", "Email"],
	  SearchKeyword: "",
      selectedRows: [],
      showAddModal: false,
      showInOutModal: false,
      md: {
        InventoryID: 0,
        ProductID: "-",
        StorageID: "-",
        Note: "",
        Quantity: "0",
        Cost: 0,
      },
      inOut: {
        InventoryID: 0,
        ProductID: 0,
        StorageID: 0,
        Note: "",
        Quantity: 0,
        Cost: 0,
        ProductName: "",
        Action: "",
        BillFile: null,
        BillCode: "",
      },
      rowEdit: {
        ID: 0,
        Number: "",
      },
      ProductSelect: [],
      /*
     [
            {
              ReqIndex: 0,
              InventoryID: 0,
              ProductID: parseInt(this.md.ProductID),
              StorageID: parseInt(this.md.StorageID),
              Quantity: parseInt(this.md.Quantity),
              SumCost: parseFloat(this.md.Cost),
              Note: this.md.Note,
            },
          ],

      */
    };
  },
  async mounted() {
    this.listData();
    this.listProduct();
    await this.listStorage();
    this.pagination.perPage = 10;
	if (this.Storage.length > 0 ) {
		this.StorageID = this.Storage[0].ID;
	}
  },
  methods: {
    ...mapActions({
      InventoryIn: "WmsInventory/InventoryIn",
      InventoryOut: "WmsInventory/InventoryOut",
      InventoryDelete: "WmsInventory/InventoryDelete",
      listData: "WmsInventory/listData",
      listProduct: "WmsProduct/listData",
      listStorage: "WmsStorage/listData",
    }),
    handleUpdateSelect() {
      this.showInOutModal = false;

      let amount = parseInt(this.inOut.Quantity)
      if (isNaN(amount)){
        return
      }

      let f = this.ProductSelect.filter(d=>d.ProductID === this.inOut.ProductID)
      if (f.length != 0){
          let index = this.ProductSelect.indexOf(f[0])
          this.ProductSelect[index].Quantity += amount 

      }else {
        this.ProductSelect.push({
            Name : this.inOut.ProductName,
            ReqIndex: 0,
            InventoryID: 0,
            ProductID: parseInt(this.inOut.ProductID),
            StorageID: parseInt(this.StorageID),
            Quantity: amount,
            SumCost: 0,
            Note: this.md.Note,
        });
      }
    },
    handleInventory() {
      this.$router.push({name : "WmsInventory"});
      // this.showAddModal = true;
    },
    handleIn(index, row) {
      this.showInOutModal = true;
      this.inOut.InventoryID = 0;
      this.inOut.ProductID = parseInt(row.ID);
      this.inOut.StorageID = 0;
      this.inOut.ProductName = row.Name;
      this.inOut.Action = "In";
    },
    handlInventoryIn() {
		this.isLoading = true;
        let Detail =  this.ProductSelect.map((d)=>{
            return {
              ReqIndex: 0,
              InventoryID:0,
              ProductID : d.ProductID,
              StorageID : this.StorageID,
              Quantity : parseInt(d.Quantity),
            }

          })

        let formData = new FormData();
        formData.append('PartnerID', 1);
        formData.append('Note', this.inOut.Note);
        formData.append('Detail', JSON.stringify(Detail));
        formData.append('BillCode', this.inOut.BillCode);
        formData.append('BillFile', this.inOut.BillFile);

        this.InventoryIn(formData)
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            }).then(()=>{
				this.$router.push({name : "WmsInventory"});
            });
          })
          .catch((err) => {
			this.isLoading = false;
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: err.response.data.Cause,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          let index = this.ProductSelect.indexOf(row)
          this.ProductSelect.splice(index,1)
          
        });
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      console.log(files[0])
        this.inOut.BillFile = files[0]
      }
  },
};
</script>
<style scope>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
